module.exports = __webpack_public_path__ + "img/Ident-Process-1.bebec5f1.png";